export default "__VITE_ASSET__DWiQry6a__"